/**
 * Skeleton for a course card (program detail page course list).
 */
export function CourseCardSkeleton() {
  return (
    <div className="rounded-2xl bg-card border border-border overflow-hidden flex flex-col h-full animate-pulse">
      <div className="p-6 flex-1 flex flex-col">
        <div className="h-5 w-full bg-muted rounded mb-2" />
        <div className="h-3 w-20 bg-muted rounded mb-4" />
        <div className="h-4 w-full bg-muted rounded mb-1" />
        <div className="h-4 w-4/5 bg-muted rounded mb-4" />
        <div className="flex gap-3 mb-4">
          <div className="h-3 w-16 bg-muted rounded" />
          <div className="h-3 w-14 bg-muted rounded" />
        </div>
        <div className="mt-auto pt-4">
          <div className="h-9 w-28 bg-muted rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function CourseCardSkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }, (_, i) => (
        <CourseCardSkeleton key={i} />
      ))}
    </div>
  );
}
